/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root.tsx'
import { Route as SecuredRouteImport } from './routes/_secured.tsx'
import { Route as AuthRouteImport } from './routes/_auth.tsx'
import { Route as IndexRouteImport } from './routes/index.tsx'
import { Route as SecuredTaxonomyRouteImport } from './routes/_secured/taxonomy.tsx'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index.tsx'
import { Route as AuthLoginAuth0IndexRouteImport } from './routes/_auth/login-auth0/index.tsx'

const SecuredClientsLazyRouteImport = createFileRoute('/_secured/clients')()
const SecuredMarginsIndexLazyRouteImport =
  createFileRoute('/_secured/margins/')()
const SecuredDashboardIndexLazyRouteImport = createFileRoute(
  '/_secured/dashboard/',
)()
const SecuredClientsIndexLazyRouteImport =
  createFileRoute('/_secured/clients/')()
const SecuredTaxonomyMetricsManagerIndexLazyRouteImport = createFileRoute(
  '/_secured/taxonomy/metrics-manager/',
)()
const SecuredTaxonomyMetadataIndexLazyRouteImport = createFileRoute(
  '/_secured/taxonomy/metadata/',
)()
const SecuredClientsClientIdIndexLazyRouteImport = createFileRoute(
  '/_secured/clients/$clientId/',
)()

const SecuredRoute = SecuredRouteImport.update({
  id: '/_secured',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_secured.lazy.tsx').then((d) => d.Route))
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_auth.lazy.tsx').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecuredClientsLazyRoute = SecuredClientsLazyRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/clients.lazy.tsx').then((d) => d.Route),
)
const SecuredTaxonomyRoute = SecuredTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/taxonomy.lazy.tsx').then((d) => d.Route),
)
const SecuredMarginsIndexLazyRoute = SecuredMarginsIndexLazyRouteImport.update({
  id: '/margins/',
  path: '/margins/',
  getParentRoute: () => SecuredRoute,
} as any).lazy(() =>
  import('./routes/_secured/margins/index.lazy.tsx').then((d) => d.Route),
)
const SecuredDashboardIndexLazyRoute =
  SecuredDashboardIndexLazyRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => SecuredRoute,
  } as any).lazy(() =>
    import('./routes/_secured/dashboard/index.lazy.tsx').then((d) => d.Route),
  )
const SecuredClientsIndexLazyRoute = SecuredClientsIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecuredClientsLazyRoute,
} as any).lazy(() =>
  import('./routes/_secured/clients/index.lazy.tsx').then((d) => d.Route),
)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/login/index.lazy.tsx').then((d) => d.Route),
)
const AuthLoginAuth0IndexRoute = AuthLoginAuth0IndexRouteImport.update({
  id: '/login-auth0/',
  path: '/login-auth0/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/login-auth0/index.lazy.tsx').then((d) => d.Route),
)
const SecuredTaxonomyMetricsManagerIndexLazyRoute =
  SecuredTaxonomyMetricsManagerIndexLazyRouteImport.update({
    id: '/metrics-manager/',
    path: '/metrics-manager/',
    getParentRoute: () => SecuredTaxonomyRoute,
  } as any).lazy(() =>
    import('./routes/_secured/taxonomy/metrics-manager/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredTaxonomyMetadataIndexLazyRoute =
  SecuredTaxonomyMetadataIndexLazyRouteImport.update({
    id: '/metadata/',
    path: '/metadata/',
    getParentRoute: () => SecuredTaxonomyRoute,
  } as any).lazy(() =>
    import('./routes/_secured/taxonomy/metadata/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )
const SecuredClientsClientIdIndexLazyRoute =
  SecuredClientsClientIdIndexLazyRouteImport.update({
    id: '/$clientId/',
    path: '/$clientId/',
    getParentRoute: () => SecuredClientsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_secured/clients/$clientId/index.lazy.tsx').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/taxonomy': typeof SecuredTaxonomyRouteWithChildren
  '/clients': typeof SecuredClientsLazyRouteWithChildren
  '/login-auth0/': typeof AuthLoginAuth0IndexRoute
  '/login/': typeof AuthLoginIndexRoute
  '/clients/': typeof SecuredClientsIndexLazyRoute
  '/dashboard/': typeof SecuredDashboardIndexLazyRoute
  '/margins/': typeof SecuredMarginsIndexLazyRoute
  '/clients/$clientId/': typeof SecuredClientsClientIdIndexLazyRoute
  '/taxonomy/metadata/': typeof SecuredTaxonomyMetadataIndexLazyRoute
  '/taxonomy/metrics-manager/': typeof SecuredTaxonomyMetricsManagerIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/taxonomy': typeof SecuredTaxonomyRouteWithChildren
  '/login-auth0': typeof AuthLoginAuth0IndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/clients': typeof SecuredClientsIndexLazyRoute
  '/dashboard': typeof SecuredDashboardIndexLazyRoute
  '/margins': typeof SecuredMarginsIndexLazyRoute
  '/clients/$clientId': typeof SecuredClientsClientIdIndexLazyRoute
  '/taxonomy/metadata': typeof SecuredTaxonomyMetadataIndexLazyRoute
  '/taxonomy/metrics-manager': typeof SecuredTaxonomyMetricsManagerIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_secured': typeof SecuredRouteWithChildren
  '/_secured/taxonomy': typeof SecuredTaxonomyRouteWithChildren
  '/_secured/clients': typeof SecuredClientsLazyRouteWithChildren
  '/_auth/login-auth0/': typeof AuthLoginAuth0IndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_secured/clients/': typeof SecuredClientsIndexLazyRoute
  '/_secured/dashboard/': typeof SecuredDashboardIndexLazyRoute
  '/_secured/margins/': typeof SecuredMarginsIndexLazyRoute
  '/_secured/clients/$clientId/': typeof SecuredClientsClientIdIndexLazyRoute
  '/_secured/taxonomy/metadata/': typeof SecuredTaxonomyMetadataIndexLazyRoute
  '/_secured/taxonomy/metrics-manager/': typeof SecuredTaxonomyMetricsManagerIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/taxonomy'
    | '/clients'
    | '/login-auth0/'
    | '/login/'
    | '/clients/'
    | '/dashboard/'
    | '/margins/'
    | '/clients/$clientId/'
    | '/taxonomy/metadata/'
    | '/taxonomy/metrics-manager/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/taxonomy'
    | '/login-auth0'
    | '/login'
    | '/clients'
    | '/dashboard'
    | '/margins'
    | '/clients/$clientId'
    | '/taxonomy/metadata'
    | '/taxonomy/metrics-manager'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_secured'
    | '/_secured/taxonomy'
    | '/_secured/clients'
    | '/_auth/login-auth0/'
    | '/_auth/login/'
    | '/_secured/clients/'
    | '/_secured/dashboard/'
    | '/_secured/margins/'
    | '/_secured/clients/$clientId/'
    | '/_secured/taxonomy/metadata/'
    | '/_secured/taxonomy/metrics-manager/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  SecuredRoute: typeof SecuredRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_secured': {
      id: '/_secured'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SecuredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secured/clients': {
      id: '/_secured/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof SecuredClientsLazyRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/taxonomy': {
      id: '/_secured/taxonomy'
      path: '/taxonomy'
      fullPath: '/taxonomy'
      preLoaderRoute: typeof SecuredTaxonomyRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/margins/': {
      id: '/_secured/margins/'
      path: '/margins'
      fullPath: '/margins/'
      preLoaderRoute: typeof SecuredMarginsIndexLazyRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/dashboard/': {
      id: '/_secured/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof SecuredDashboardIndexLazyRouteImport
      parentRoute: typeof SecuredRoute
    }
    '/_secured/clients/': {
      id: '/_secured/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof SecuredClientsIndexLazyRouteImport
      parentRoute: typeof SecuredClientsLazyRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-auth0/': {
      id: '/_auth/login-auth0/'
      path: '/login-auth0'
      fullPath: '/login-auth0/'
      preLoaderRoute: typeof AuthLoginAuth0IndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_secured/taxonomy/metrics-manager/': {
      id: '/_secured/taxonomy/metrics-manager/'
      path: '/metrics-manager'
      fullPath: '/taxonomy/metrics-manager/'
      preLoaderRoute: typeof SecuredTaxonomyMetricsManagerIndexLazyRouteImport
      parentRoute: typeof SecuredTaxonomyRoute
    }
    '/_secured/taxonomy/metadata/': {
      id: '/_secured/taxonomy/metadata/'
      path: '/metadata'
      fullPath: '/taxonomy/metadata/'
      preLoaderRoute: typeof SecuredTaxonomyMetadataIndexLazyRouteImport
      parentRoute: typeof SecuredTaxonomyRoute
    }
    '/_secured/clients/$clientId/': {
      id: '/_secured/clients/$clientId/'
      path: '/$clientId'
      fullPath: '/clients/$clientId/'
      preLoaderRoute: typeof SecuredClientsClientIdIndexLazyRouteImport
      parentRoute: typeof SecuredClientsLazyRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginAuth0IndexRoute: typeof AuthLoginAuth0IndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginAuth0IndexRoute: AuthLoginAuth0IndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface SecuredTaxonomyRouteChildren {
  SecuredTaxonomyMetadataIndexLazyRoute: typeof SecuredTaxonomyMetadataIndexLazyRoute
  SecuredTaxonomyMetricsManagerIndexLazyRoute: typeof SecuredTaxonomyMetricsManagerIndexLazyRoute
}

const SecuredTaxonomyRouteChildren: SecuredTaxonomyRouteChildren = {
  SecuredTaxonomyMetadataIndexLazyRoute: SecuredTaxonomyMetadataIndexLazyRoute,
  SecuredTaxonomyMetricsManagerIndexLazyRoute:
    SecuredTaxonomyMetricsManagerIndexLazyRoute,
}

const SecuredTaxonomyRouteWithChildren = SecuredTaxonomyRoute._addFileChildren(
  SecuredTaxonomyRouteChildren,
)

interface SecuredClientsLazyRouteChildren {
  SecuredClientsIndexLazyRoute: typeof SecuredClientsIndexLazyRoute
  SecuredClientsClientIdIndexLazyRoute: typeof SecuredClientsClientIdIndexLazyRoute
}

const SecuredClientsLazyRouteChildren: SecuredClientsLazyRouteChildren = {
  SecuredClientsIndexLazyRoute: SecuredClientsIndexLazyRoute,
  SecuredClientsClientIdIndexLazyRoute: SecuredClientsClientIdIndexLazyRoute,
}

const SecuredClientsLazyRouteWithChildren =
  SecuredClientsLazyRoute._addFileChildren(SecuredClientsLazyRouteChildren)

interface SecuredRouteChildren {
  SecuredTaxonomyRoute: typeof SecuredTaxonomyRouteWithChildren
  SecuredClientsLazyRoute: typeof SecuredClientsLazyRouteWithChildren
  SecuredDashboardIndexLazyRoute: typeof SecuredDashboardIndexLazyRoute
  SecuredMarginsIndexLazyRoute: typeof SecuredMarginsIndexLazyRoute
}

const SecuredRouteChildren: SecuredRouteChildren = {
  SecuredTaxonomyRoute: SecuredTaxonomyRouteWithChildren,
  SecuredClientsLazyRoute: SecuredClientsLazyRouteWithChildren,
  SecuredDashboardIndexLazyRoute: SecuredDashboardIndexLazyRoute,
  SecuredMarginsIndexLazyRoute: SecuredMarginsIndexLazyRoute,
}

const SecuredRouteWithChildren =
  SecuredRoute._addFileChildren(SecuredRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  SecuredRoute: SecuredRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
